// extracted by mini-css-extract-plugin
export var contentBody = "_4q-9";
export var headerImage = "_4q-2";
export var imageButton = "_4q-7";
export var imageButtonIcon = "_4q-8";
export var imageHeader = "_4q-4";
export var imageHeaderText = "_4q-5";
export var imageOverlay = "_4q-3";
export var imageTitle = "_4q-6";
export var imageWrapper = "_4q-1";
export var taskList = "_4q-a";
export var widget = "_4q-0";